import { Steps, Tabs } from "antd";
import React from "react";
import close from "../../assets/cancel.svg";
import PopupComponent from "../../common/Popup";
import { acutal_key, planned_key, ship_status } from "./ShipmentDetails";
import moment from "moment";
const { Step } = Steps;
const { TabPane } = Tabs;

const ShipmentTrackPopup = ({
  open,
  setOpen,
  shipment_detail,
  setOpenHis,
  shipment_track,
}) => {
  return (
    <PopupComponent open={open} width={620}>
      <div className="popup-wrap order-detail">
        <img
          src={close}
          alt="close"
          width={14}
          style={{
            position: "absolute",
            right: 20,
            top: 10,
            cursor: "pointer",
          }}
          onClick={() => setOpen(false)}
        />
        <div className="flex-start">
          <h2
            style={{
              fontSize: "1.2rem",
              fontWeight: 600,
            }}
          >
            Shipment ID - #{shipment_detail?.ShipNo}
          </h2>
        </div>
        <div className="flex-between">
          <div>
            {/* <div>Shipment ID :{shipment_detail.DeliveryNo}</div> */}
            <div>ETD Date : {shipment_detail?.EtdDate === "00000000" ? "" : moment(
              shipment_detail?.EtdDate,
              "YYYYMMDD"
            ).format("MMM DD, YYYY")}</div>
            <div>ETA Date : {shipment_detail?.EtaDate === "00000000" ? "" : moment(
              shipment_detail?.EtaDate,
              "YYYYMMDD"
            ).format("MMM DD, YYYY")}</div>
          </div>
          <div>
            {/* <div>Container ID : {shipment_detail?.Container}</div> */}
            <div>Vessel Name: {shipment_detail?.VesselNo}</div>
            <div>Tracking No : </div>
          </div>
        </div>
        <div
          className="tabs"
          style={{
            maxHeight: "20rem",
          }}
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Status">
              <div className="status">
                <div className="ml1 mt1">
                  <Steps
                    direction="vertical"
                    progressDot
                    current={Number(shipment_track?.transport_status) + 1}
                  >
                    {Object.keys(ship_status).map((ele) => (
                      <Step
                        title={
                          <div className="box">
                            {ship_status[ele]}
                            {/* eslint-disable-next-line */}
                            {ele == 6 && <span className="ml2 cursor evision" onClick={() => { setOpenHis(true) }}>Evision Status</span>}
                            <div className="d-flex w100">
                              <span>
                                Planned:{" "}
                                {parseInt(
                                  shipment_track?.[planned_key[ele].date]
                                )
                                  ? moment(
                                    shipment_track?.[planned_key[ele].date],
                                    "YYYYMMDD"
                                  ).format("MMM DD, YYYY")
                                  : " - "}&nbsp;
                                {parseInt(
                                  shipment_track?.[planned_key[ele].time]
                                )
                                  ? moment(
                                    shipment_track?.[planned_key[ele].time],
                                    "hhmmss"
                                  ).format("HH:mm")
                                  : ""}
                              </span>
                              <span>
                                Actual:
                                {parseInt(
                                  shipment_track?.[acutal_key[ele].date]
                                )
                                  ? moment(
                                    shipment_track?.[acutal_key[ele].date],
                                    "YYYYMMDD"
                                  ).format("MMM DD, YYYY")
                                  : " - "}&nbsp;
                                {parseInt(
                                  shipment_track?.[acutal_key[ele].time]
                                )
                                  ? moment(
                                    shipment_track?.[acutal_key[ele].time],
                                    "hhmmss"
                                  ).format("HH:mm")
                                  : ""}
                              </span>
                            </div>
                          </div>
                        }
                      />
                    ))}
                  </Steps>
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </PopupComponent>
  );
};

export default ShipmentTrackPopup;
